import { motion, useReducedMotion } from 'framer-motion';

export const Reveal = ({ children, className = '', delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div className={className} initial={{ opacity: reduced ? 1 : 0, y: reduced ? 0 : 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: .1 }} transition={{ duration: .75, delay, ease: [.22, 1, .36, 1] }} {...props}>{children}</motion.div>;
};